import { AlimtalkTemplate } from '../../../types/alimtalk/template';
import { ALIMTALK_PREVIEW_FALLBACK } from './constants';
import * as Styled from './style';

export type KakaoPreviewProps = {
  template: AlimtalkTemplate;
  /** 운영자가 선택한 실제 변수 값. 미선택 변수는 placeholder([쿠폰명] 등) 또는 per-user 샘플로 대체 */
  variableValues?: Record<string, string>;
};

// own-property만 조회 — {{constructor}} 같은 프로토타입 키가 함수 소스로 렌더되는 것 방지
const ownValue = (record: Record<string, string>, key: string): string | undefined =>
  Object.prototype.hasOwnProperty.call(record, key) ? record[key] : undefined;

// 선택값(variableValues) 우선 → 없으면 폴백(placeholder/샘플) → 그래도 없으면 {{변수}} 유지.
// PreviewConfirmModal도 공유 — 백엔드 preview는 ACTION 모드에서 원문을 주므로 운영자 선택값 치환은 클라 담당.
export const renderAlimtalkText = (message: string, variableValues: Record<string, string>): string =>
  message.replace(
    /\{\{(\w+)\}\}/g,
    (_match, key: string) => ownValue(variableValues, key) ?? ownValue(ALIMTALK_PREVIEW_FALLBACK, key) ?? `{{${key}}}`,
  );

export const KakaoPreview = (props: KakaoPreviewProps) => {
  const { template, variableValues = {} } = props;

  if (!template.messageTemplate) {
    return <Styled.KakaoNoAlimtalk>알림톡 메시지가 없는 유형입니다. (쿠폰 발급만)</Styled.KakaoNoAlimtalk>;
  }

  return (
    <Styled.KakaoBubble>
      <Styled.KakaoHeader>알림톡 도착</Styled.KakaoHeader>
      <Styled.KakaoContent>
        <Styled.KakaoBody>{renderAlimtalkText(template.messageTemplate, variableValues)}</Styled.KakaoBody>
      </Styled.KakaoContent>
      {template.buttons.length > 0 && (
        <Styled.KakaoButtonGroup>
          {template.buttons.map((button, index) => (
            <Styled.KakaoButton key={`${button.name}-${index}`}>{button.name}</Styled.KakaoButton>
          ))}
        </Styled.KakaoButtonGroup>
      )}
    </Styled.KakaoBubble>
  );
};
